import { CategoryView } from 'ish-core/models/category-view/category-view.model';
import { Product, VariationProduct, VariationProductMaster } from 'ish-core/models/product/product.model';

export type ProductView = Partial<Omit<VariationProductMasterView, 'type'>> &
  Partial<Omit<VariationProductView, 'type'>> &
  Partial<SimpleProductView>;

interface SimpleProductView extends Product {
  defaultCategory: CategoryView;
}

interface VariationProductView extends VariationProduct, SimpleProductView {
  type: VariationProduct['type'];

  variations: VariationProduct[]; //TO BE REMOVED AFTER FIXING  PRODUCT VARIATION LIST

  productMaster: VariationProductMaster; //TO BE REMOVED AFTER FIXING  PRODUCT VARIATION LIST
}

interface VariationProductMasterView extends VariationProductMaster, SimpleProductView {
  type: VariationProductMaster['type'];
  variations: VariationProduct[]; //TO BE REMOVED AFTER FIXING  PRODUCT VARIATION LIST
  defaultVariationSKU: string;
}

export function createProductView(product: Product, defaultCategory?: CategoryView): SimpleProductView {
  return (
    product && {
      ...product,
      defaultCategory,
    }
  );
}

export function createVariationProductMasterView(
  product: VariationProductMaster,
  defaultVariationSKU: string,
  defaultCategory?: CategoryView,
  //TO BE REMOVED AFTER FIXING  PRODUCT VARIATION LIST  START
  variations?: VariationProduct[]
  //TO BE REMOVED AFTER FIXING  PRODUCT VARIATION LIST END
): VariationProductMasterView {
  return (
    product && {
      ...createProductView(product, defaultCategory),
      type: 'VariationProductMaster',
      defaultVariationSKU,
      //TO BE REMOVED AFTER FIXING  PRODUCT VARIATION LIST START
      variations,
      //TO BE REMOVED AFTER FIXING  PRODUCT VARIATION LIST END
    }
  );
}

export function createVariationProductView(
  product: VariationProduct,
  defaultCategory?: CategoryView,
  //TO BE REMOVED AFTER FIXING  PRODUCT VARIATION LIST  START
  variations?: VariationProduct[],
  productMaster?: VariationProductMaster
  //TO BE REMOVED AFTER FIXING  PRODUCT VARIATION LIST END
): VariationProductView {
  return (
    product && {
      ...createProductView(product, defaultCategory),
      type: 'VariationProduct',
      //TO BE REMOVED AFTER FIXING  PRODUCT VARIATION LIST START
      variations,
      productMaster,
      //TO BE REMOVED AFTER FIXING  PRODUCT VARIATION LIST END
    }
  );
}
